import {
  compose,
  legacy_createStore as createStore,
  applyMiddleware,
} from 'redux';
import { thunk } from 'redux-thunk';

import reducers from '../reducers';

const initialState = {};
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let middleware = applyMiddleware(thunk);

if (process.env.NODE_ENV !== 'production') {
  middleware = composeEnhancers(middleware);
}

const store = createStore(reducers, initialState, middleware);
export default store;
